<template>
	<div class="EchartsData">
		<p>当前数据范围：{{gradeVal}}（{{classVal}}）</p>
		<a-spin :spinning="!relation" size="large">
			<div class="contentArea">
			<div v-if="relation && relation.length" id="k"></div>
			<div v-else class="none">
				<img src="@/assets/echartsNone.png" alt="">
				数据采集中，敬请期待！
			</div>
		</div>
		</a-spin>
	</div>
</template>

<script>
// 引入基本模板
let echarts = require('echarts/lib/echarts')
// 引入柱状图组件
require('echarts/lib/chart/graph')
// 引入提示框和title组件
require('echarts/lib/component/tooltip')
// 引入图例
require('echarts/lib/component/legend')
import { mapState, mapActions } from 'vuex'
import URL from '@/store/url'
import ECHARTSDATA from '@/util/echartsData.js'

let newItem = null // 每个学生的UID
const teacherAdmin = JSON.parse(sessionStorage.getItem('teacherAdmin'))
const info = JSON.parse(sessionStorage.getItem('userInfo'))
window.onClickSeries = () => {
  window.open(`${URL.TO_RECORD}?UID=${newItem}&teacherId=${teacherAdmin.uid}&schoolName=${teacherAdmin.school_name}&city=${teacherAdmin.city}&token=${teacherAdmin.tokenValue}&schoolId=${info.school_id}&roleId=${info.role_id}&jwt=${teacherAdmin.jwt}`)
}
export default {
	name: 'echartsData',
	props: [
		'gradeId',
		'classId',
		'gradeVal',
		'classVal',
		'qid'
	],
	data () {
		return {
			active: null,
			datas: null,
			lines: null,
			categories: [
				{
					name: "0"
				},
				{
					name: "1"
				},
				{
					name: "2"
				},
				{
					name: "3"
				},
				{
					name: "4"
				},
				{
					name: "5"
				}
			]
		}
	},
	computed: {
		...mapState([
			'relation'
		]),
		newParams () {
			return {qid: this.qid, gradeId: this.gradeId, classId: this.classId}
		}
	},
	methods: {
		...mapActions([
			'getRelation'
		]),
		async search (info) {
			if (document.getElementById("k")) {
				echarts.init(document.getElementById("k")).dispose()
			}
			await this.getRelation({gradeId: info.gradeId, classId: parseInt(info.classId), qid: info.qid})
			if (this.relation && this.relation.length) {
				this.datas = ECHARTSDATA(this.relation).datas
				this.lines = ECHARTSDATA(this.relation).lines
				this.drawChart()
			}
		},
		drawChart () {
			this.$nextTick(() => {
				// 基于准备好的dom，初始化echarts实例
				let myChart = echarts.init(document.getElementById("k"))
				// 指定图表的配置项和数据
				let option = {
					tooltip: {
						enterable: true,
						// 触发方式 mousemove, click, none, mousemove|click
						triggerOn: `click`, 
						// item 图形触发， axis 坐标轴触发， none 不触发
						trigger: `item`, 
						// 浮层隐藏的延迟
						hideDelay: 800,
						// 背景色
						backgroundColor: `rgba(255, 255, 255)`,
						borderWidth: 1,
						borderColor: '#eee',
						extraCssText: 'box-shadow:0 0 8px rgba(81, 81,81,0.8)',
						textStyle: {
							color: '#333'
						},
						formatter: (params) => {
							if (params.dataType === 'node') { // 鼠标在’点‘上
								newItem = params.data.uid
								if (info.role_id === 1) {
									return `<div class=chartLabel>
									<div class=title style="color: #333333;text-align: center">${params.name}</div>
									<div class=title>被${params.value}名同学选择为好友</div>
									<div style="text-align: center"><button id="btn-tooltip" onclick="onClickSeries()">查看学生档案</button></div>
									</div>`
								} else {
									return `<div class=chartLabel>
									<div class=title style="color: #333333;text-align: center">${params.name}</div>
									<div class=title>被${params.value}名同学选择为好友</div>
									</div>`
								}
								
							} else { // 鼠标在’线‘上
								return params.data.sourceName + ' ➞ ' + params.data.targetName
							}
						}
					},
					color: ['#ea4779', '#ef7e4b', '#33cccc', '#007bca', '#66cc33', '#66cc33'],
					legend: [
						{
							show: false,
							data: this.categories.map(function (a) {
								return a.name;
							})
						}
					],
					series: [
						{
							name: '朋友数量',//系列名称
							type: 'graph',//图表类型
							layout: 'force',//echarts3的变化，force是力向图，circular是和弦图
							draggable: true,//指示节点是否可以拖动
							data: this.datas,
							links: this.lines,
							categories: this.categories,
							legendHoverLink: true,
							focusNodeAdjacency: true,//当鼠标移动到节点上，突出显示节点以及节点的边和邻接节点
							roam: true,//是否开启鼠标缩放和平移漫游。默认不开启。如果只想要开启缩放或者平移，可以设置成 'scale' 或者 'move'。设置成 true 为都开启
							nodeScaleRatio: 0.6,
							zoom: 2,
							edgeSymbol: ['circle', 'arrow'], // 指向箭头
							edgeSymbolSize: [4, 10],
							edgeLabel: {
								fontSize: 20
							},
							label: {
								position: 'right',
								formatter: '{b}'
							},
							lineStyle: {
								color: 'source',
								curveness: 0.3
							},
							emphasis: {
								focus: 'adjacency',
								lineStyle: {
									width: 10
								}
							}
						}
					]
				}
				// 使用刚指定的配置项和数据显示图表。
				myChart.setOption(option, true)
			})
    }
  },
	watch: {
		async newParams () {
			if (document.getElementById("k")) {
				echarts.init(document.getElementById("k")).dispose()
			}
			await this.getRelation({gradeId: this.gradeId, classId: parseInt(this.classId.substring(0, this.classId.length - 1)), qid: this.qid})
			if (this.relation && this.relation.length) {
				let data = ECHARTSDATA(this.relation)
				this.datas = data.datas
				this.lines = data.lines
				this.drawChart()
			}
		}
	},
	async mounted () {
		await this.getRelation({gradeId: this.gradeId, classId: parseInt(this.classId.substring(0, this.classId.length - 1)), qid: this.qid})
		if (this.relation && this.relation.length) {
			let data = ECHARTSDATA(this.relation)
			this.datas = data.datas
			this.lines = data.lines
			this.drawChart()
		}
	}
}
</script>

<style>
.EchartsData > p {
	margin-top: 16px;
	margin-bottom: 8px;
}
.contentArea {
	height: 300px;
}
.EchartsData, #k {
  width: 100%;
	height: 300px!important;
}
.EchartsData .none {
	height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	color: #999999;
}
.EchartsData .none img {
	width: 200px;
	height: auto;
	margin-bottom: 15px;
}
#btn-tooltip {
	border-radius: 4px;
	background: #FFFFFF;
	border: 1px solid #eee;
	cursor: pointer;
	margin-top: 4px;
	font-size: 12px;
	padding: 2px 12px;
	transition: all 0.3s;
	color: #999999;
}
#btn-tooltip:hover {
	border-color: #51BF94;
	color: #51BF94;
}
</style>
